<template>
    <div class="review-block">
        <p class="review-block__copy">{{ copy }}</p>
    </div>
</template>

<script>
export default {
    name: 'ReviewsBlock',
    props: {
        copy: String,
    }
}
</script>